import { render, staticRenderFns } from "./InboxDropdownItem.vue?vue&type=template&id=15209d00&scoped=true&"
import script from "./InboxDropdownItem.vue?vue&type=script&lang=js&"
export * from "./InboxDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./InboxDropdownItem.vue?vue&type=style&index=0&id=15209d00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15209d00",
  null
  
)

export default component.exports